import React from 'react';
import { Translate, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { popupActions } from '../../../store/popupStore';
import { reportActions, SECTIONS } from '../../../store/reportStore';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import NoDataComponent from '../../common/noDataComponent';
import RatingCard from '../rating/ratingCard';

class ESGScoreOverview extends React.Component {

    shouldComponentUpdate(nextProps, _) {
        return this.props.dataHash !== nextProps.dataHash;
    }

    render() {
        return (isNullOrUndefined(this.props.data) ? <NoDataComponent /> : <div>{this.renderContent(this.props.data)}</div>);
    }

    renderContent(data) {
        return (
            <>
                <div>
                    <Translate id="Report.ESG.ScoreOverview.Title" />
                </div>
                <div className='esg-score-overview'>
                    <RatingCard
                        cardType="ESGScoreOverview"
                        title={this.props.translate("Report.ESG.ScoreOverview.ScoreESG")}
                        tooltip={this.props.translate("Report.ESG.ScoreOverview.ScoreESG.Tooltip")}
                        onFurtherInfoLinkClick={this.scrollToSectionFunction(SECTIONS.esgScoreOverview)}
                    >
                        <div className="columns is-tablet is-multiline is-centered ">
                            <div className="column is-12 center-content">
                                <div className={`esg-main-score esg-gradient-${data.esg}`}><span>{data.esg}</span></div>
                            </div>
                            <div className="column is-4-widescreen is-12-mobile is-4">
                                <RatingCard
                                    white
                                    cardType="ESGScoreE"
                                    title={this.props.translate("Report.ESG.ScoreOverview.ScoreE")}
                                    onFurtherInfoLinkClick={this.scrollToSectionFunction(SECTIONS.esgScoreE)}
                                >
                                    <span className={`esg-score esg-color-${data.e}`}>{data.e}</span>
                                </RatingCard>
                            </div>
                            <div className="column is-4-widescreen is-12-mobile is-4">
                                <RatingCard
                                    white
                                    cardType="ESGScoreS"
                                    title={this.props.translate("Report.ESG.ScoreOverview.ScoreS")}
                                    onFurtherInfoLinkClick={this.scrollToSectionFunction(SECTIONS.esgScoreS)}
                                >
                                    <span className={`esg-score esg-color-${data.s}`}>{data.s}</span>
                                </RatingCard>
                            </div>
                            <div className="column is-4-widescreen is-12-mobile is-4">
                                <RatingCard
                                    white
                                    cardType="ESGScoreG"
                                    title={this.props.translate("Report.ESG.ScoreOverview.ScoreG")}
                                    onFurtherInfoLinkClick={this.scrollToSectionFunction(SECTIONS.esgScoreG)}
                                >
                                    <span className={`esg-score esg-color-${data.g}`}>{data.g}</span>
                                </RatingCard>
                            </div>
                        </div>
                    </RatingCard>
                </div>
            </>
        );
    }

    scrollToSectionFunction = (topSection, simpleSection, sectionHasData) => {
        const section = this.props.report.sections.find(i => i.id === topSection);
        if (section && section.hidden) {
            return null;
        }

        return _ => ((section, simpleSection, sectionHasData) => {
            if (section) {
                if (!section.hidden) {
                    this.props.scrollToSection(section, simpleSection, sectionHasData);
                }
            } else {
                this.props.showPopup('informationMessagePopup', { open: true, close: () => this.props.hidePopup(), message: this.props.translate("UnhappyUser.NotAllowedAction") });
            }
        })(section, simpleSection, sectionHasData);
    }

}

export default withLocalize(connect(
    state => ({ report: state.report }),
    dispatch => bindActionCreators(({ ...reportActions, ...popupActions }), dispatch)
)(ESGScoreOverview));
